import React from "react";
import "./ProviderBadge.css";
import { elakayAutoText } from "../../pageInside/dataElakay";

// Petit badge réutilisé partout où un ProviderProduct/lien Seller doit être
// visuellement distingué d'un produit Seller natif ou d'un import CJ (spec
// §17/§18 -- ne jamais laisser deviner qu'un produit vient d'un Provider
// interne aux yeux du client final ; ce badge est réservé aux vues
// Provider/Seller/Admin, jamais rendu sur la page produit publique).
const ProviderBadge = ({ label = elakayAutoText("h_dsw_role_provider", "Provider") }) => (
  <span className="provider-badge">{label}</span>
);

export default ProviderBadge;
